const SUBMISSION_MISSING_VALUE = "N/A";

const submissionTypeBadgeClasses = {
  ORIG: "border border-emerald-300/40 bg-emerald-400/15 text-emerald-100",
  SUPPL: "border border-sky-300/40 bg-sky-400/15 text-sky-100",
  N_A: "border border-slate-600 bg-slate-800/70 text-slate-100",
};

const submissionCodeBadgeClasses = {
  EFFICACY: "border border-fuchsia-300/40 bg-fuchsia-400/15 text-fuchsia-100",
  LABELING: "border border-amber-300/40 bg-amber-400/15 text-amber-100",
  MANUFACTURING: "border border-cyan-300/40 bg-cyan-400/15 text-cyan-100",
  LOW: "border border-slate-500/40 bg-slate-700/40 text-slate-200",
  NEUTRAL: "border border-slate-600 bg-slate-800/70 text-slate-100",
};

const getSubmissionText = (value) => {
  if (value === null || value === undefined) {
    return SUBMISSION_MISSING_VALUE;
  }

  const normalized = String(value).trim();
  return normalized || SUBMISSION_MISSING_VALUE;
};

const formatSubmissionDate = (value) => {
  const textValue = getSubmissionText(value);
  if (textValue === SUBMISSION_MISSING_VALUE) {
    return SUBMISSION_MISSING_VALUE;
  }

  const normalized = textValue.replace(/-/g, "").trim();
  if (!/^\d{8}$/.test(normalized)) {
    return textValue;
  }

  const parsedDate = new Date(
    `${normalized.slice(0, 4)}-${normalized.slice(4, 6)}-${normalized.slice(6, 8)}T00:00:00Z`
  );
  if (Number.isNaN(parsedDate.getTime())) {
    return normalized;
  }

  return parsedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
};

const getSubmissionType = (submission, fallbackType = "SUPPL") => {
  const submissionType = getSubmissionText(submission?.submission_type);
  return submissionType === SUBMISSION_MISSING_VALUE ? fallbackType : submissionType;
};

const getSubmissionTitle = (submission, fallbackType = "SUPPL") => {
  const type = getSubmissionType(submission, fallbackType);
  const number = getSubmissionText(submission?.submission_number);
  return `${type} ${number}`;
};

const getSubmissionCodeClassName = (badge) => {
  const code = String(badge?.code || badge?.label || "").toUpperCase();

  if (code.includes("EFFICACY")) {
    return submissionCodeBadgeClasses.EFFICACY;
  }

  if (code.includes("LABELING")) {
    return submissionCodeBadgeClasses.LABELING;
  }

  if (code.includes("MANUF") || code.includes("CMC")) {
    return submissionCodeBadgeClasses.MANUFACTURING;
  }

  if (badge?.tier === "low") {
    return submissionCodeBadgeClasses.LOW;
  }

  return submissionCodeBadgeClasses.NEUTRAL;
};

const buildSubmissionFacts = (submission) => [
  ["Type", getSubmissionText(submission?.submission_type)],
  ["Number", getSubmissionText(submission?.submission_number)],
  ["Status", getSubmissionText(submission?.submission_status)],
  ["Date", formatSubmissionDate(submission?.submission_status_date)],
  ["Review", getSubmissionText(submission?.review_priority)],
  [
    "Class",
    getSubmissionText(
      submission?.submission_class_code_description || submission?.submission_class_code
    ),
  ],
];

export {
  SUBMISSION_MISSING_VALUE,
  buildSubmissionFacts,
  formatSubmissionDate,
  getSubmissionCodeClassName,
  getSubmissionText,
  getSubmissionTitle,
  getSubmissionType,
  submissionCodeBadgeClasses,
  submissionTypeBadgeClasses,
};
